module.exports = __webpack_public_path__ + "img/recv_req_mob.png";